import * as tslib_1 from "tslib";
/**
 * Copyright 2012-2018 the original author or authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Pipe } from '@angular/core';
/**
 * Changes the case of the first letter of a given number of words in a string.
 * @author Randika Hapugoda
 */
var CamelCasePipe = /** @class */ (function () {
    function CamelCasePipe() {
    }
    CamelCasePipe.prototype.transform = function (input, length) {
        if (input == undefined)
            return '';
        return input.charAt(0).toUpperCase() + input.substring(1).replace(/[A-Z]/g, ' $&');
    }; // transform
    CamelCasePipe = tslib_1.__decorate([
        Pipe({ name: 'camelCase', pure: false })
    ], CamelCasePipe);
    return CamelCasePipe;
}()); // class
export { CamelCasePipe };
//# sourceMappingURL=camelCase.pipe.js.map